import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const auth = useAuth()
  const location = useLocation()
  if (auth.loading) return <div className="page-loader">正在载入开发者空间…</div>
  if (!auth.user) return <Navigate to="/" replace state={{ authFrom: location.pathname + location.search }} />
  return children
}
